import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HourMeterComponent } from './components/hour-meter/hour-meter.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EmbeddedPowerAppComponent } from './components/embedded-power-app/embedded-power-app.component';

@NgModule({
  declarations: [HourMeterComponent, EmbeddedPowerAppComponent],
  imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule],
  exports: [HourMeterComponent, EmbeddedPowerAppComponent],
})
export class SharedModule {}
